import { useMemo } from 'react';

import { useTranslations } from 'next-intl';

import { Image } from '@/components/shared/Image';

type T_Variant = 'predictions' | 'pools' | 'referrals';

interface I_SectionIconsProps {
  variant: T_Variant;
}

export function SectionIcons({ variant }: I_SectionIconsProps) {
  const t = useTranslations();

  const icons = useMemo(() => {
    switch (variant) {
      case 'predictions':
        return (
          <Image
            width={509}
            height={509}
            alt={t('predictions.title')}
            src="/assets/images/account/predictions.png"
            className="w-full h-full"
          />
        );
      case 'pools':
        return (
          <Image
            width={509}
            height={509}
            alt={t('pools.title')}
            src="/assets/images/account/pools.png"
            className="w-full h-full"
          />
        );
      case 'referrals':
        return (
          <Image
            width={509}
            height={509}
            alt={t('referrals.title')}
            src="/assets/images/account/referrals.png"
            className="w-full h-full"
          />
        );
      default:
        return;
    }
  }, [t, variant]);

  return <>{icons}</>;
}
